import { SEND_SERVERSIDE_FPTI_ACTION, MAX_EVENTS_TO_LOG } from './FPTIConstants';

export default (state = [], action) => {
    switch (action.type) {
        case SEND_SERVERSIDE_FPTI_ACTION:
            return [
                action.payload,
                ...state
            ].slice(0, MAX_EVENTS_TO_LOG);
        default:
            return state;
    }
};
